import React from 'react';
import AppTextLogo from '@/Components/Utility/AppTextLogo';
import { Link } from '@inertiajs/react';

const ContainerForm = ({ children, title }) => {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-gray-100 px-4 sm:pt-0">
      <Link href="/">
        <AppTextLogo style="dark" />
      </Link>
      <div className="py-4shadow-md mt-6 w-full overflow-hidden rounded-lg px-6 sm:max-w-md">
        <h4>{title}</h4>
        {children}
      </div>
    </div>
  );
};

export default ContainerForm;
